import { asyncComponent } from '../../hoc'

export const DatePicker = asyncComponent(() => import('./DatePicker'))
export const SingleDatePicker = asyncComponent(() => import('./SingleDatePicker'))